function updateObject(obj, arr) {
    arr.forEach(([key, value]) => {
      obj[key] = value;
    });
    return obj;
  }

  export default updateObject